var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n    Menampilkan "+_vm._s(_vm._f("number")(_vm.current))+" dari "+_vm._s(_vm._f("number")(_vm.total))+" "+_vm._s(_vm.unit)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }